import React, { useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Gheader } from './Gheader';
import styles from './Document.module.css';
import FilterButton from './FilterButton';
import DocumentTable from './DocumentTable';
import DocumentModel from './DocumentModel';
import apiService from '../api/apiService';
import { ToastContainer } from 'react-toastify';

export const Document = () => {
  const hotelId = localStorage.getItem('hotel');
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [guests, setGuests] = useState([]);

  /* Fetching Documents from API */
  useEffect(() => {
    fetchDocuments();
    fetchGuests();
  }, []);

  const fetchDocuments = async () => {
    try {
      const response = await apiService.get(`/documents/?hotel=${hotelId}`);
      setDocumentData(response);
    } catch (error) {
      console.error('Error fetching documents:', error);
      setDocumentData([]); // Prevent undefined state
    }
  };

  const fetchGuests = async () => {
    try {
      const response = await apiService.get(`/guests/?hotel=${hotelId}`);
      setGuests(response);
    } catch (error) {
      console.error('Error fetching documents:', error);
      setGuests([]);
    }
  };

  const addDocument = newDocument => {
    setDocumentData(prevData => [newDocument, ...prevData]);
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3 className="ps-2 ps-md-0">Documents</h3>
          <div className={`${styles.buttonContainer} ps-2 ps-md-0 `}>
            <button
              className={styles.addRateButton}
              onClick={() => setIsModelOpen(true)}
            >
              Add Document
            </button>
            {/* <FilterButton /> */}
          </div>

          <DocumentTable
            data={documentData}
            setData={setDocumentData}
            guests={guests}
            hotelId={hotelId}
            setEditingItem={setEditingItem}
          />

          {isModelOpen && (
            <DocumentModel
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              onSave={addDocument}
              guests={guests}
              hotelId={hotelId}
              existingData={editingItem}
            />
          )}
        </div>
      </div>

      <ToastContainer autoClose={1500} />
    </div>
  );
};

export default Document;
